import { Icon } from "antd";

export default Icon.createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_878963_8g3py0i2cz2.js" // 在 iconfont.cn 上生成
});